import { Injectable } from '@angular/core';
import axios from 'axios';
import { environment } from '../environments/environment';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AppService {
    tokenObject:any = new BehaviorSubject<{}>({});
    token$:any = this.tokenObject.asObservable();

    setIntervalTime = 60000;
    //initialRender=true;
   
    async getTokens(){
        console.log('getting power bi tokens')
        await this.getPowerbiToken();
        setInterval(()=>{
            this.updatePowerbiToken()
        },this.setIntervalTime)   
    }
     async getPowerbiToken(){
        if(!this.tokenObject["access_token"])
        {    
            const result=await axios.get(environment.apiURL+'/getPowerBiToken')
            console.log('got token object==>',result.data)
            this.setTokenObject(result.data);
            console.log(this.tokenObject["access_token"],'Service call');
        }
    }
    async updatePowerbiToken(){
        console.log("Token refesh initiated");
        if(this.tokenObject["refresh_token"])
        {   
            const result=await axios.post(environment.apiURL +'/refreshPowerBiToken',{refresh_token:this.tokenObject["refresh_token"]})
            this.setTokenObject(result.data);
        }
    }

    setTokenObject(data: {}) {
        this.tokenObject.next(data);
      }
    

}